import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import colorConvert from "color-convert";
import { scale } from "../utils/utils";
const Color = require("color");
class FillColor extends LitElement {
  static get properties() {
    return {
      source: { type: String },
      ccSource: { type: String },
      size: { type: Number },
      backgroundColor: { type: String },
      startColor: { type: String },
      endColor: { type: String },
      noteColor: { type: String },
      lowNote: { type: Number },
      highNote: { type: Number },
      colorSystem: { type: String },
      colorValues: { type: Array },
      orientation: { type: String },
      width: { type: String },
      height: { type: String },
      top: { type: String },
      right: { type: String },
      bottom: { type: String },
      left: { type: String },
      startPosition: { type: String },

      widthDivision: { type: Number },
      heightDivision: { type: Number },
      offset: { type: Number },
      position: { type: String },
      opacity: { type: Number },
      mixBlendMode: { type: String },
      ccResponsive: { type: Boolean },
      knobOneNumber: { type: Number },
      knobTwoNumber: { type: Number },
      knobThreeNumber: { type: Number },
      knobFourNumber: { type: Number },
      knobOneValue: { type: Number },
      knobTwoValue: { type: Number },
      knobThreeValue: { type: Number },
      knobFourValue: { type: Number },
      lightness: { type: Number },
      activeNotes: { type: Array },
      cycleColorValues: { type: Array },
      pitchDetection: { type: Boolean },
      opacityCC: { type: Number },
      ccSource: { type: String },
      boxShadow: { type: String },
      randomColors: { type: Array },
      opacityIncrement: { type: Number },
      randomColor: { type: Boolean },
      cycleColor: { type: Boolean },
      cycleColors: { type: Array },
      noteOpacity: { type: Number },
    };
  }

  constructor() {
    super();

    // input
    this.source = null;
    this.ccSource = null;
    this.lowNote = 21;
    this.highNote = 108;

    // size
    this.size = 1;

    // color
    this.backgroundColor = "rgb(0, 0, 0";
    this.startColor = "blue";
    this.endColor = "red";
    this.noteColor = null;
    this.opacity = 1;
    this.boxShadow = "0";
    this.mixBlendMode = "normal";

    // responsive color
    this.colorValues = [0, -1, 0, 0];
    this.colorSystem = "cmyk";

    // position
    this.position = "absolute";
    this.orientation = "vertical";
    this.startPosition = "left";
    this.width = "100%";
    this.height = "100%";
    this.widthDivision = 1;
    this.heightDivision = 1;
    this.left = "0";
    this.top = "0";
    this.bottom = "0";
    this.right = "0";
    this.offset = 0;

    // note attributes
    this.activeNotes = [];
    this.container = null;

    // fill color properties
    this.activeColorIdx = 0;
    this.opacityIncrement = 0.1;
    this.randomColor = false;
    this.cycleColors = ["rgb(255, 0, 0)", "rgb(0, 0, 255)"];
    this.noteOpacity = 1;

    // web midi
    WebMidi.enable((error) => {
      if (error) {
        console.log(error);
      } else {
        const midiSource = WebMidi.getInputByName(this.source);
        const ccSource = WebMidi.getInputByName(this.ccSource);

        if (midiSource) {
          midiSource.addListener("noteon", "all", this.handleNoteOn.bind(this));
          midiSource.addListener(
            "noteoff",
            "all",
            this.handleNoteOff.bind(this)
          );
        }

        if (ccSource) {
          ccSource.addListener(
            "controlchange",
            "all",
            this.handleControlChange.bind(this)
          );
        }
      }
    });
  }

  handleNoteOn(e) {
    if (e.note.number >= this.lowNote && e.note.number <= this.highNote) {
      this.container = this.shadowRoot.querySelector("#container");
      const element = document.createElement("div");
      element.id = `note${e.note.number}`;

      const { note } = e;
      note.velocity = scale(e.velocity, 0, 1, 0, 127);
      element.style = this.getNoteStyle(note);

      this.activeNotes.push(element);
      this.container.appendChild(element);
    }
  }

  handleNoteOff(e) {
    if (e.note.number >= this.lowNote && e.note.number <= this.highNote) {
      const elements = this.shadowRoot.querySelectorAll(
        `#note${e.note.number}`
      );

      const timerId = setInterval(() => {
        elements.forEach((element) => {
          element.style.opacity = element.style.opacity - this.opacityIncrement;
          if (element.style.opacity === 0) {
            elements.forEach((element) => {
              this.container.removeChild(element);
            });
            clearTimeout(timerId);
          }
        });
      }, 1);
    }
  }

  handleControlChange(e) {
    console.log(e.controller.number);
    if (this.opacityCC === e.controller.number) {
      this.opacity = scale(e.value, 0, 127, 0, 1);
    }
  }

  getNoteColorResponsive(note) {
    if (!note) {
      return;
    }

    let system = this.colorSystem;
    let rgb = "";
    let responsiveColor;

    responsiveColor = this.colorValues.map((val) => {
      if (val === -1) {
        if (system === "cmyk") {
          return Math.floor(scale(note.velocity, 0, 127, 0, 100));
        }
        if (system === "lab") {
          return Math.floor(scale(note.velocity, 0, 127, 0, 100));
        }
        if (system === "rgb") {
          return Math.floor(scale(note.velocity, 0, 127, 0, 255));
        }
      } else {
        return val;
      }
    });

    if (system === "rgb") {
      rgb = responsiveColor;
    } else if (system === "cmyk") {
      rgb = colorConvert.cmyk.rgb(responsiveColor);
    } else if (system === "lab") {
      rgb = colorConvert.lab.rgb(responsiveColor);
    }

    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${1})`;
  }

  getNoteColor(note) {
    console.log(note);
    if (this.noteColor !== null) {
      return this.noteColor;
    }
    const factor = scale(note.number, this.lowNote, this.highNote - 1, 0, 1);
    const color = Color.hsl(this.startColor);
    const mixedColor = color.mix(Color.hsl(this.endColor), factor);
    return mixedColor;
  }

  getCycleColor() {
    let color;
    color = this.cycleColors[this.activeColorIdx];
    this.activeColorIdx =
      this.activeColorIdx < this.cycleColors.length - 1
        ? this.activeColorIdx + 1
        : 0;
    return `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
  }

  getRandomColor() {
    const color = Color.rgb(Math.floor(Math.random() * 255), 0, 0);
    return color;
  }

  getNoteStyle(note) {
    let style = ``;

    const containerHeight = window
      .getComputedStyle(this.container)
      .height.slice(0, -2);

    const containerWidth = window
      .getComputedStyle(this.container)
      .width.slice(0, -2);

    // const offsetAxis =
    //   this.startPosition === "top" || this.startPosition === "bottom"
    //     ? containerHeight
    //     : containerWidth;

    // const posOffset = scale(
    //   note.number - this.offset,
    //   this.lowNote,
    //   this.highNote,
    //   0,
    //   offsetAxis
    // );

    style = `
      position: absolute;
      width: ${containerWidth};
      height: ${containerHeight};
      background: ${this.getCycleColor()};
      opacity: ${this.noteOpacity};
    `;

    return style;
  }

  render() {
    if (WebMidi.supported) {
      return html`
        <style>
          :host {
            margin: 0 auto;
          }
          #container {
            position: ${this.position};
            display: inline-block;
            width: ${this.width
              ? this.width
              : `calc(100% / ${this.widthDivision})`};

            height: ${this.height
              ? this.height
              : `calc(100% / ${this.heightDivision})`};

            left: ${this.left};
            top: ${this.top};
            background: ${this.backgroundColor};
            opacity: ${this.opacity};
            box-shadow: ${this.boxShadow};
            mix-blend-mode: ${this.mixBlendMode};
          }
        </style>
        <div id="container"></div>
      `;
    } else {
      return html``;
    }
  }
}

customElements.define("fill-color", FillColor);
